module.exports = __webpack_public_path__ + "img/minus.430b91d3.png";